module.exports = __webpack_public_path__ + "img/UserManual.8b1165ed.png";